import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import {
  GetSecureInformationRequestsByCorporation,
  ISecureInformationRequest,
} from './types';

function useFilteredSecureInformationRequest(
  complianceId: string | undefined,
  corporationId: number | null,
  token?: string,
  caFirmId?: string
) {
  const query = new URLSearchParams();

  if (corporationId) query.append('corporationId', corporationId.toString());

  if (complianceId) query.append('complianceId', complianceId);

  if (caFirmId) query.append('caFirmId', caFirmId);

  const endpoint = `secureInformationRequest?${query}`;

  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?:
      | ISecureInformationRequest[]
      | GetSecureInformationRequestsByCorporation;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    endpoint,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: corporationId
      ? (data as GetSecureInformationRequestsByCorporation)
      : (data as ISecureInformationRequest[]),
    error,
    isLoading,
    mutate,
  };
}

export { useFilteredSecureInformationRequest };
